module.exports = __webpack_public_path__ + "static/uni_spelman-bf5c560ebfe63c8e22534435543f94ef.png";